import {
	LOOK_IMAGE_DEFAULT,
	TYPE_IMAGES_DEFAULT,
} from 'my-purchases/constants/constants'
import {
	type Product,
	type ProductImageType,
	type ProductSize,
} from 'product/types'

export const normalizeGetImage = ({
	product,
	colorId,
	sizeId,
}: {
	product: Product
	colorId: string
	sizeId?: string
}) => {
	const { colors } = product
	const color = colors.find(({ id }) => id === colorId)

	let imageToShow: string | null = null
	let size: ProductSize | undefined
	if (color) {
		const { images } = color.looks[LOOK_IMAGE_DEFAULT]
		TYPE_IMAGES_DEFAULT.forEach((defaultType) => {
			const image = images[defaultType as ProductImageType]?.img
			if (image && !imageToShow) {
				imageToShow = image
			}
		})
		size = color.sizes.find(({ id }) => id === sizeId)
	}

	return { imageToShow, color, size }
}
